export default {
    cep: [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
    numero: [/\d/, /\d/, /\d/, /\d/],
}